import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import styles from './Tag.module.less';

const Tag = ({ children, className, ...otherProps }) => {
  return (
    <div className={clsx(styles.tagBody, className)} {...otherProps}>
      {children}
    </div>
  );
};

Tag.displayName = 'Tag';
Tag.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Tag;
